import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { client } from "../utils/client";
import { feedQuery, searchQuery } from "../utils/data";
import { Masonry, Spinner } from ".";

const Feed = () => {
  const [pins, setPins] = useState();
  const [loading, setLoading] = useState(false);
  const { categoryId } = useParams();

  useEffect(() => {
    if (categoryId) {
      setLoading(true);
      const query = searchQuery(categoryId);
      client.fetch(query).then((data) => {
        setPins(data);
        setLoading(false);
      });
    } else {
      setLoading(true);

      client.fetch(feedQuery).then((data) => {
        setPins(data);
        setLoading(false);
      });
    }
  }, [categoryId]);

  const ideaName = categoryId || "new";
  if (loading) {
    return (
      <Spinner message={`We are adding ${ideaName} posts to your feed!`} />
    );
  }

  if (pins?.length === 0) return <h2>No pins available</h2>;

  return <div>{pins && <Masonry pins={pins} />}</div>;
};

export default Feed;
